
<!-- <div id="google_translate_element"></div> -->

<div class="app-outer-container" [attr.color-theme]="colorTheme">
    <ngx-loading-bar [height]="'3px'" [color]="'#0168fa'" [diameter]="'30px'"></ngx-loading-bar>
    <ng-http-loader [backdrop]="true"
    [backgroundColor]="'#000000'"
    [debounceDelay]="100"
    [extraDuration]="300"
    [minDuration]="300"
    [opacity]=".8"
    [backdropBackgroundColor]="'#dee2e6'"></ng-http-loader>
    <router-outlet></router-outlet>
</div>
